<template>
  <div>
    <!-- <el-card :span="6" v-if="permissions.indexOf('/distributionLevel/pageList') > -1"> -->
    <!-- <el-card :span="6">
      <el-form ref="searchForm" :model="searchForm">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-button
              :size="componentSize"
              type="primary"
              @click="pageList"
              icon="el-icon-search"
            >查询</el-button>
            <el-button :size="componentSize" type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>-->

    <el-card>
      <!-- <el-row :span="24">
        <el-col :span="12">
          <el-button
            :size="componentSize"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
            v-if="permissions.indexOf('/distributionLevel/addDistributionLevel') > -1"
          >新增</el-button>
          <el-button
            :size="componentSize"
            type="danger"
            @click="batchDeleteDistributionLevel"
            icon="el-icon-minus"
            v-if="permissions.indexOf('/distributionLevel/deleteDistributionLevel') > -1"
          >批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button
            :size="componentSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
            v-if="permissions.indexOf('/distributionLevel/import') > -1"
          >导入</el-button>
          <el-button
            :size="componentSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
            v-if="permissions.indexOf('/distributionLevel/export') > -1"
          >导出</el-button>
        </el-col>
      </el-row>-->
      <el-button
        size="small"
        type="primary"
        @click="addFormVisible = true"
        icon="el-icon-plus"
      >等级</el-button>
      <el-table
        :size="componentSize"
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" :index="indexMethod" label="排序" width="50" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="credits" label="信用额度（元）" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="commission" label="代理抽成%" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="agentCount" label="机构数" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="operationGroup" style="display: flex;justify-content: flex-start;">
              <!-- <span
                @click="selection = scope.row.id, detailFormVisible = true"
              >
                <i class="el-icon-view" title="查看"></i>
              </span>-->
                <i @click="selection = scope.row.id, editFormVisible = true" style="width:50%" class="el-icon-edit mainColor" title="编辑"></i>
             
                <i v-if="scope.row.agentCount==0" @click="deleteDistributionLevel(scope.row)" style="width:50%" class="el-icon-delete mainColor" title="删除"></i>
            
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <!-- <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      :width="addFormDialogWidth"
      left
      v-if="permissions.indexOf('/distributionLevel/addDistributionLevel') > -1"
    >-->
    <el-dialog title="添加机构等级" :visible.sync="addFormVisible" :width="addFormDialogWidth" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <!-- <el-form-item label="机构" prop="agentId">
            <el-select v-model="addForm.agentId" clearable style="width:100%">
              <el-option v-for="(item,index) in agentInfoList" :key="index" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="等级名称" prop="name">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              v-model="addForm.name"
              placeholder="请输入等级名称"
              auto-complete="off"
              maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="信用额度" prop="credits">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              type="number"
              v-model="addForm.credits"
              placeholder="请输入信用额度"
              auto-complete="off"
              maxlength="10"
              clearable
            >
            <template slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="代理抽成" prop="commission">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              type="number"
              v-model="addForm.commission"
              placeholder="请输入代理抽成"
              auto-complete="off"
              maxlength="10"
              clearable
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button
          :size="componentSize"
          type="primary"
          @click="addDistributionLevel"
          :loading="blockAddDistributionLevel"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="detailFormVisible"
      :width="detailFormDialogWidth"
      left
      v-if="permissions.indexOf('/distributionLevel/getDistributionLevel') > -1"
    >
      <el-form
        class="detail-form-dialog"
        ref="detailForm"
        :model="detailForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构" prop="agentId">{{detailForm.agentId}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="name">{{detailForm.name}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="信用额度" prop="credits">{{detailForm.credits}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提成" prop="commission">{{detailForm.commission}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :width="editFormDialogWidth"
      left
      v-if="permissions.indexOf('/distributionLevel/updateDistributionLevel') > -1"
    >-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :width="editFormDialogWidth" left>
      <el-form
        class="edit-form-dialog"
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :gutter="20">
          <!-- <el-form-item label="机构" prop="agentId">
            <el-select v-model="editForm.agentId" clearable style="width:100%">
              <el-option v-for="(item,index) in agentInfoList" :key="index" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="等级名称" prop="name">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              v-model="editForm.name"
              placeholder="请输入等级名称"
              auto-complete="off"
              maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="信用额度" prop="credits">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              type="number"
              v-model="editForm.credits"
              placeholder="请输入信用额度"
              auto-complete="off"
              maxlength="10"
              clearable
            ><template slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="代理抽成" prop="commission">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              type="number"
              v-model="editForm.commission"
              placeholder="请输入代理抽成"
              auto-complete="off"
              maxlength="10"
              clearable
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="editFormVisible = false">取 消</el-button>
        <el-button
          :size="componentSize"
          type="primary"
          @click="updateDistributionLevel"
          :loading="blockEditDistributionLevel"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      width="80%"
      left
      v-if="permissions.indexOf('/distributionLevel/import') > -1"
    >
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="componentSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        :size="componentSize"
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="agentId" label="机构"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="credits" label="信用额度"></el-table-column>
        <el-table-column prop="commission" label="提成"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="componentSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
        >导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      blockAddDistributionLevel: false,
      blockEditDistributionLevel: false,
      blockDeleteDistributionLevel: false,
      blockBatchDeleteDistributionLevel: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      componentSize: "",
      addFormDialogWidth: "",
      detailFormDialogWidth: "",
      editFormDialogWidth: "",
      addFormVisible: false,
      detailFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      agentInfoList: [],
      searchForm: {},
      addForm: {
        agentId: null,
        name: null,
        credits: null,
        commission: null
      },
      addFormRules: {
        agentId: [
          {
            required: true,
            message: "请输入机构",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入机构名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "名称长度在0-255个字"
          }
        ],
        credits: [
          {
            required: true,
            message: "请输入信用额度",
            trigger: "blur"
          },
          {
            min: 0,
            max: 10,
            message: "信用额度长度在0-10个字"
          },
          {
            validator: (rule, value, callback) => {
            if (this.addForm.credits<0) {
            callback(new Error('信用额度不能小于0'));
            }
            callback();
            },
          },
        ],
        commission: [
          {
            required: true,
            message: "请输入代理提成",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
            var start = this.addForm.commission;
            if (this.addForm.commission>100||this.addForm.commission<0) {
            callback(new Error('代理提成不能小于0且小于100'));
            }
            callback();
            },
          },
          {
            min: 0,
            max: 10,
            message: "提成长度在0-10个字"
          }
        ]
      },
      detailForm: {
        agentId: null,
        name: null,
        credits: null,
        commission: null
      },
      editForm: {
        agentId: null,
        name: null,
        credits: null,
        commission: null
      },
      editFormRules: {
        agentId: [
          {
            required: true,
            message: "请输入机构",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        credits: [
          {
            required: true,
            message: "请输入信用额度",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
            if (this.editForm.credits<0) {
            callback(new Error('信用额度不能小于0'));
            }
            callback();
            },
          },
        ],
        commission: [
          {
            required: true,
            message: "请输入提成",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
            if (this.editForm.commission>100||this.editForm.commission<0) {
            callback(new Error('代理提成不能小于0且小于100'));
            }
            callback();
            },
          },
        ]
      },
      importForm: {},
      searchFormLabelWidth: "0px",
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      rangePickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/distributionLevel/uploadExcel`,
      fileList: [],
      loading: false,
      permissions: []
    };
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.page.pageNumber - 1) * 10;
    },
    setComponentSize() {
      if (document.body.clientWidth <= 992) {
        this.componentSize = "mini";
        return;
      }
      if (document.body.clientWidth <= 1200) {
        this.componentSize = "small";
        return;
      }
      if (document.body.clientWidth <= 1920) {
        this.componentSize = "medium";
        return;
      }
    },
    setDialogWidth() {
      if (document.body.clientWidth > 1366) {
        this.addFormDialogWidth = "30%";
      } else {
        this.addFormDialogWidth = "40%";
      }
      if (document.body.clientWidth > 1366) {
        this.detailFormDialogWidth = "40%";
      } else {
        this.detailFormDialogWidth = "50%";
      }
      if (document.body.clientWidth > 1366) {
        this.editFormDialogWidth = "30%";
      } else {
        this.editFormDialogWidth = "40%";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.ids = [];
      val.forEach(e => this.ids.push({ id: e.id }));
    },
    getDistributionLevelDetail() {
      this.api.distributionLevel
        .getDistributionLevelDetail({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.detailForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDistributionLevel() {
      this.api.distributionLevel
        .getDistributionLevel({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.editForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAgentInfoList() {
      this.api.agentInfo.getAgentInfoList().then(result => {
        if (result.success) {
          this.agentInfoList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    pageList() {
      this.tableLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.distributionLevel
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addDistributionLevel() {
      if (this.blockAddDistributionLevel) {
        return false;
      }
      setTimeout(()=>{this.blockAddDistributionLevel = false},5000);
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.blockAddDistributionLevel = true;
          this.api.distributionLevel
            .addDistributionLevel(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
              this.blockAddDistributionLevel = false;
            })
            .catch(error => {
              this.blockAddDistributionLevel = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateDistributionLevel() {
      if (this.blockEditDistributionLevel) {
        return false;
      }
      setTimeout(() => {
        this.blockEditDistributionLevel = false;
      }, 5000);
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.blockEditDistributionLevel = true;
          this.api.distributionLevel
            .updateDistributionLevel(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockEditDistributionLevel = false;
            })
            .catch(error => {
              this.blockEditDistributionLevel = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteDistributionLevel(row) {
      if (this.blockDeleteDistributionLevel) {
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockDeleteDistributionLevel = true;
          this.api.distributionLevel
            .deleteDistributionLevel([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockDeleteDistributionLevel = false;
            })
            .catch(error => {
              this.blockDeleteDistributionLevel = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteDistributionLevel() {
      if (this.blockBatchDeleteDistributionLevel) {
        return false;
      }
      if (this.ids.length === 0) {
        this.$message.error("请选择要删除的数据！");
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockBatchDeleteDistributionLevel = true;
          this.api.distributionLevel
            .deleteDistributionLevel(this.ids)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockBatchDeleteDistributionLevel = false;
            })
            .catch(error => {
              this.blockBatchDeleteDistributionLevel = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.distributionLevel
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.distributionLevel
        .importData(this.importForm.rows)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.importFormVisible = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    active(row) {
      this.api.distributionLevel
        .active(row)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
          this.pageList();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          a.resources.forEach(x => this.permissions.push(x.url));
        });
      });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
        this.getAgentInfoList();
      }
    },
    detailFormVisible: function(newVal) {
      if (newVal) {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".detail-form-dialog")
        });
        loading.close();
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        // let loading = this.$loading.service({
        //   text: "请稍等",
        //   target: document.querySelector(".edit-form-dialog")
        // });
        this.getDistributionLevel();
        // loading.close();
      }
    }
  },
  mounted() {
    this.setComponentSize();
    this.setDialogWidth();
    // this.getPermissionList();
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/distributionLevel/index.vue